<widget-card
    [cardTitle]="dataSource?.cardTitle"
    [actionLabel]="dataSource?.headerButtonText"
    [helpButtonUrl]="dataSource.helpButtonUrl"
    (actionClick)="dataSource.headerButtonClick()"
>
    <developer-helper [datasourceCode]="OldDataSourceCode.ACTION" />
    <div class="grid-container grid-3" [ngClass]="{ hidden: mode !== 'pie' }">
        <div #chartCanvas class="chart grid-span-2"></div>
        <div class="vertical-center">
            <div class="width-100">
                @for (point of data; track point) {
                    <div class="info">
                        <div>
                            <span class="value" [coloredTextColor]="point.color">{{ point.value }}</span>
                            <span class="unit sse-grey-dark">{{ point.label | translate | lowercase }}</span>
                        </div>
                        @if (point.icon) {
                            <ui-icon size="large" [name]="point.icon" [color]="point.color" />
                        }
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="vertical-center">
        @if (mode !== 'pie') {
            <loading-and-error
                [hasNoData]="mode === 'nodata'"
                [isLoading]="mode === 'loading'"
                [noDataTitle]="dataSource.noDataTitle | translate"
                [noDataMessage]="dataSource.noDataSubtitle | translate"
            />
        }
    </div>
</widget-card>
